import request from 'api/request';

export default function makePrimaryEmailRoute(email) {
  return request({
    url: '/emails/make-primary',
    method: 'PUT',
    data: { email },
  });
}
